@if (viewMode === ViewModelEnum.ReturnValues) {
    <div [ngClass]="{ 'overridden': lookupHasOverride }">
        {{ lookupValue }}
    </div>
}
@if (viewMode === ViewModelEnum.Settings) {
    <select
        name="lookup"
        class="form-select form-select-sm"
        [ngClass]="{ 'overridden': lookupHasOverride }"
        [(ngModel)]="lookupId"
        (ngModelChange)="selectionChanged($event)"
        [disabled]="isReadonly"
    >
        @for (lo of options; track lo) {
            <option [ngValue]="lo.lookupId"
                    [ngStyle]="{ 'color': !isTopLevelCompany && lo.lookupId !== ('' + parentLookupId) ? 'red' : 'black' }">
                {{ lo.name }}
            </option>
        }
    </select>
}
